import React, { useState } from "react";
import {
  StyledCalendarWrapper,
  StyledCalendar,
  StyledDate,
  StyledToday,
  StyledHolidayCount,
  StyledMyDot,
  StyledEduLine,
  StyledMyEduLine,
  StyledMyWorks,
} from "./Styles";
import dayjs from "dayjs";

function Calendar({
  className = "",
  navClassName = "",
  dateClassName = "",
  todayButtonYn = true,
  holidays = [],
  myHolidays = [],
  edus = [],
  myEdus = [],
  myWorks = [],
  dateState,
  onChange = (e) => {},
  onActiveStartDateChange = (e) => {},
  onViewChange = (e) => {},
}) {
  const today = new Date();
  const [activeStartDate, setActiveStartDate] = useState(new Date());

  const handleDateChange = (newDate) => {
    onChange(newDate);
  };

  const handleTodayClick = () => {
    const today = new Date();
    setActiveStartDate(today);
    onChange(today);
  };

  return (
    <StyledCalendarWrapper className={className}>
      <StyledCalendar
        className={navClassName}
        value={dateState}
        onChange={handleDateChange}
        formatDay={(locale, date) => dayjs(date).format("D")}
        formatYear={(locale, date) => dayjs(date).format("YYYY")}
        formatMonthYear={(locale, date) => dayjs(date).format("YYYY. MM")}
        calendarType="gregory"
        showNeighboringMonth={false}
        next2Label={null}
        prev2Label={null}
        minDetail="year"
        activeStartDate={activeStartDate || undefined}
        onActiveStartDateChange={({ activeStartDate }) => {
          setActiveStartDate(activeStartDate);
          onActiveStartDateChange(activeStartDate);
        }}
        tileContent={({ date, view }) => {
          let html = [];
          if (
            view === "month" &&
            date.getFullYear() === today.getFullYear() &&
            date.getMonth() === today.getMonth() &&
            date.getDate() === today.getDate()
          ) {
            html.push(<StyledToday key={"today"}>오늘</StyledToday>);
          }
          if (
            holidays.find((x) => x.day === dayjs(date).format("YYYY-MM-DD"))
          ) {
            html.push(
              <StyledHolidayCount
                key={`holidays-${dayjs(date).format("YYYY-MM-DD")}`}
                style={{
                  top:
                    dayjs(date).format("YYYY-MM-DD") ==
                    dayjs(new Date()).format("YYYY-MM-DD")
                      ? "55%"
                      : "40%",
                }}
              >{`(${
                holidays.filter(
                  (f) => f.day == dayjs(date).format("YYYY-MM-DD")
                )[0].count
              })`}</StyledHolidayCount>
            );
          }
          if (myHolidays.find((x) => x === dayjs(date).format("YYYY-MM-DD"))) {
            html.push(
              <StyledMyDot
                key={`myHolidays-${dayjs(date).format("YYYY-MM-DD")}`}
              />
            );
          }
          if (edus.find((x) => x === dayjs(date).format("YYYY-MM-DD"))) {
            html.push(
              <StyledEduLine key={`edus-${dayjs(date).format("YYYY-MM-DD")}`} />
            );
          }
          if (myEdus.find((x) => x === dayjs(date).format("YYYY-MM-DD"))) {
            html.push(
              <StyledMyEduLine
                key={`myEdus-${dayjs(date).format("YYYY-MM-DD")}`}
              />
            );
          }
          if (myWorks.find((x) => x === dayjs(date).format("YYYY-MM-DD"))) {
            html.push(
              <StyledMyWorks
                key={`myWorks-${dayjs(date).format("YYYY-MM-DD")}`}
              />
            );
          }
          return <>{html}</>;
        }}
        onViewChange={(e) => onViewChange}
      />
      {/* 오늘 버튼 추가 */}
      {todayButtonYn ? (
        <StyledDate className={dateClassName} onClick={handleTodayClick}>
          오늘
        </StyledDate>
      ) : null}
    </StyledCalendarWrapper>
  );
}

export default Calendar;
